module.exports = __webpack_public_path__ + "static/34-b5ad24b9068b4f1eec70218009090211.png";